import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-text-icon',
  imports: [],
  templateUrl: './text-icon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './text-icon.scss',
})
export class TextIcon {
  text = input.required<string>();
  color = input<string>('white');
}
